import React, { useRef, useEffect } from 'react';
import '../../css/OffersCarousel.css';

const baseOffers = [
  { text: "Flat 100 off on order above 999 t&C.", code: "FLAT100" },
  { text: "Get Flat 10% Off on your First Purchase.", code: "WELCOME10" },
  { text: "Get 5% discount on order above 1000.", code: "GET5" },
];

const OffersCarousel = () => {
  const scrollRef = useRef(null);

  const offers = [...baseOffers]; // prepend, original, append

  const offerCardWidth = 300; // Match with CSS card width + margin

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollAmount = offerCardWidth;

    container.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const container = scrollRef.current;
    const cardCount = baseOffers.length;

    // Start at original set (middle)
    container.scrollLeft = cardCount * offerCardWidth;

    const interval = setInterval(() => {
      scroll('right');

      // Seamless loop logic
      setTimeout(() => {
        if (!container) return;

        if (container.scrollLeft >= (cardCount * 2 * offerCardWidth)) {
          container.scrollLeft = cardCount * offerCardWidth;
        }
      }, 400); // Delay to wait for scroll animation to finish
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="offers-section">
      <div className="offers-header">
        <h2>Available Offers</h2>
        <div className="nav-buttons">
          <button onClick={() => scroll('left')}>
            <i className="fa-solid fa-caret-left"></i>
          </button>
          <button onClick={() => scroll('right')}>
            <i className="fa-solid fa-caret-right"></i>
          </button>
        </div>
      </div>

      <div className="offers-carousel" ref={scrollRef}>
        {offers.map((offer, index) => (
          <div className="offer-card" key={index}>
            <div className="offer-text">{offer.text}</div>
            <div className="offer-footer">
              <span>Use Code</span>
              <strong>{offer.code}</strong>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OffersCarousel;
